import { render, staticRenderFns } from "./ToplistItem.vue?vue&type=template&id=6c60f44e&"
import script from "./ToplistItem.vue?vue&type=script&lang=js&"
export * from "./ToplistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports